import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgDesktop = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.75 4.45H5.25a2.625 2.625 0 0 0-2.625 2.624v12.25A2.625 2.625 0 0 0 5.25 21.95h7.875v1.75H10.5a.875.875 0 0 0 0 1.75h7a.875.875 0 1 0 0-1.75h-2.625v-1.75h7.875a2.625 2.625 0 0 0 2.625-2.625V7.074A2.625 2.625 0 0 0 22.75 4.45ZM5.25 6.2h17.5a.875.875 0 0 1 .875.874v8.75H4.375v-8.75A.875.875 0 0 1 5.25 6.2Zm17.5 14H5.25a.875.875 0 0 1-.875-.876v-1.75h19.25v1.75a.875.875 0 0 1-.875.875Z" />
  </svg>
);
export default SvgDesktop;
